import { render } from "./OpenInAppButton.vue?vue&type=template&id=5251d45a&scoped=true"
import script from "./OpenInAppButton.vue?vue&type=script&lang=js"
export * from "./OpenInAppButton.vue?vue&type=script&lang=js"

import "./OpenInAppButton.vue?vue&type=style&index=0&id=5251d45a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5251d45a"]])

export default __exports__